import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import Loader from 'apollo-react/components/Loader';
import React from 'react';

const useStyles = makeStyles({
  card: {
    height: 160,
    width: '100%',
    position: 'relative',
    border: 'none',
    boxShadow: 'none',
  },
});

const SearchResultLoader = () => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Loader isInner />
    </Card>
  );
};

export default SearchResultLoader;
